// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"eccb73e9543291a8b6c2","691":"5cade48a0eba0719a1e9"}[chunkId] + ".js";
};